import { Navigate, useParams } from 'react-router-dom';

// import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS } from '@/shared';
import { useGetContrato } from '@/shared/actions/erp';
import { SaveServicioClienteComponent } from '../../shared/components/SaveServicioClienteComponent';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateServicioClientePageProps { }

const UpdateServicioClientePage: React.FC<UpdateServicioClientePageProps> = () => {
  // useCheckPermissions(PermissionsEnum.api_change_contrato);
  const returnUrlServicioClientesPage = ROUTER_PATHS.activaciones.activacionActServicioClientesActualizar;

  const { id } = useParams();
  const { data, isLoading } = useGetContrato(id!);

  // if (isLoading || isRefetching) return null;
  if (isLoading) 
    return <LoaderComponent />

  if (!data?.data?.id_contrato)
    return <Navigate to={returnUrlServicioClientesPage} />;


  return <SaveServicioClienteComponent title="Editar Servicio de Cliente" contrato={data.data} />;
};

export default UpdateServicioClientePage;
